import React from "react";
import { Button, Spinner } from "reactstrap";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";
import { useVsiAppContext } from "../stores/VsiApp";

function AcknowledgeButton ({ disable, onAcknowledge, acknowledgedToggle, buttonDisplayOverride, allowAcknowledge, isLoading}) {

  const {theme} = useVsiAppContext();

  if (!allowAcknowledge) return null
  return <Button
    disabled={!!disable}
    className={"float-end m-2"}
    onClick={onAcknowledge}>
    {buttonDisplayOverride || (acknowledgedToggle ? "Unacknowledge Alerts" : "Acknowledge Alerts")}
    {isLoading ? <Spinner size={"sm"} color={theme} className={"ms-1"}/> : null}
  </Button>
}

export default withErrorBoundary(AcknowledgeButton, GeneralErrorBoundary);
